export default __webpack_public_path__ + "static/slider_4-6d4cfca480ffe0cd056fb585062adf09.png";